import * as React from "react";
import { Input } from "react-ui";

import { Caption, Row, Value } from "../../FiasFnsManualEditor.styles";

interface SteadProps {
    value: string | undefined;
    onValueChange: (next: string) => void;
}

export function Stead({ value, onValueChange }: SteadProps): JSX.Element | null {
    return (
        <Row>
            <Caption>Номер земельного участка</Caption>
            <Value>
                <Input
                    width={350}
                    maxLength={255}
                    value={value ?? ""}
                    placeholder={"Номер земельного участка"}
                    data-tid={"Stead"}
                    onValueChange={next => onValueChange(next)}
                />
            </Value>
        </Row>
    );
}
